import appLogo from "_assets/images/tjpb_logo.png";
import { Flex, HStack, VStack } from "_ui/Box";
import LanguageSelector from "../../../components/languages/LanguageSelector";
import powerGoogleCloud from "../../../components/assets/img/power-by-google-cloud.png";
import { Breadcrumb, Nav } from "react-bootstrap";
import { LimitedWidth } from "_page/LimitedWidth";
import { observable } from "@legendapp/state";
import { observer } from "@legendapp/state/react";

export const $subTitle = observable<string>('Atendimento Virtual');

export const Header = observer(() => {
    return (
        <VStack wFull className='default-client-header'>
            <LimitedWidth>
                <Flex between wFullVw alignCenter wrap>
                    <VStack g={3}>
                        <HStack alignCenter g={3}>
                            {/* <a href='/' title='Inicio'>
                                <img src={appLogo} alt="TJPB" style={{ maxWidth: 45 }} />
                            </a> */}

                            <HStack alignCenter g={2} wrap style={{maxWidth: '90%'}}>
                                <h2>Central de atendimentos</h2>
                                {/* <div id="header-sutitle">
                                    <span>•</span>
                                    <h4>{$subTitle.get()}</h4>
                                </div> */}
                            </HStack>

                        </HStack>
                    </VStack>
                    <HStack alignCenter>
                        <img src={powerGoogleCloud} alt="google-cloud-img" className="my-auto g-cloud"
                            style={{ maxWidth: 200 }} />
                    </HStack>
                </Flex>
            </LimitedWidth>
        </VStack>
    );
});
